var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleLeftSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 160,
    viewBox: "0 0 346 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.894 3.93202C130.124 2.33649 131.458 2.29337 144.282 2.20713L327.441 1.17218C334.413 1.17218 335.532 6.34686 336.005 10.5297C338.372 30.2797 342.246 63.8289 342.719 83.4496C342.977 95.2219 343.063 107.081 343.063 118.982V126.744C343.063 128.556 344.828 127.866 344.828 131.574C344.828 135.498 341.686 142.441 329.593 142.829C323.267 143.088 306.44 142.57 302.911 141.449C301.706 141.061 301.147 141.061 301.061 139.983C300.243 129.849 295.638 118.12 288.408 114.282C283.072 111.436 269.344 111.479 263.448 114.282C255.314 118.12 250.838 128.556 250.58 138.905C250.193 140.802 249.289 142.096 248.342 142.096L86.873 142.829C85.625 142.829 83.6884 142.613 83.5593 141.018C82.0961 125.537 75.5547 115.403 67.8514 112.385C62.2567 110.229 53.6926 111.048 48.4423 112.902C36.6506 117.042 34.1115 132.307 32.0888 141.708C23.869 143.088 19.7376 143.217 12.5937 141.104C8.3332 139.897 0.586852 136.318 1.01721 131.747L1.74879 123.467C1.92093 121.397 2.91075 119.629 4.11574 119.414C3.212 109.15 2.86767 106.908 8.37621 99.836C14.5303 91.9446 25.074 85.9507 33.1647 80.086C35.0583 78.7061 38.7594 75.3857 39.6631 73.2727H43.7945C54.8976 60.336 71.3802 43.3889 84.549 30.8403C92.3815 23.3802 103.485 13.807 112.78 8.33049C115.75 6.69184 119.537 4.6651 122.894 3.93202Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.193 115.576C343.193 116.741 343.193 117.862 343.193 119.026V126.788C343.193 128.642 345 127.909 345 131.618C345 135.542 341.859 142.485 329.766 142.916C329.593 142.916 329.378 142.916 329.163 142.916V115.576H343.193Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.04 22.4325L135.46 143.132",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.173 20.7938L329.034 137.44L301.018 137.483",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.598 83.9679C113.598 83.9248 113.598 83.9248 113.641 83.8817C113.813 82.7174 114.717 82.0706 116.18 81.855C117.643 81.6825 117.772 81.6825 119.106 81.855C120.397 82.0274 121.258 82.8036 121.602 83.8817C121.258 82.8467 120.397 82.0274 119.106 81.855C117.772 81.6825 117.6 81.6825 116.18 81.855C114.717 82.0706 113.813 82.7174 113.641 83.8817C113.598 83.8817 113.598 83.9248 113.598 83.9679Z",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.646 86.4684C121.431 87.5033 120.484 88.7108 119.15 88.8833C117.773 89.0558 117.601 89.0558 116.224 88.8833C114.804 88.7108 113.771 87.8915 113.685 86.8565C113.642 86.684 113.642 86.5547 113.642 86.4253C113.685 86.5547 113.685 86.684 113.685 86.8565C113.771 87.8915 114.804 88.6677 116.224 88.8833C117.601 89.0558 117.773 89.0558 119.15 88.8833C120.484 88.7108 121.388 87.5033 121.646 86.4684Z",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.397 86.4256C120.354 86.3825 120.354 86.2531 120.354 86.21V84.1401C120.354 84.0539 120.397 83.9676 120.397 83.9245H109.681C109.165 83.9245 108.777 84.3126 108.777 84.8732V85.4769C108.777 85.9944 109.165 86.4256 109.681 86.4256H120.397Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0704 129.591C41.212 121.182 49.4748 115.49 58.4693 115.49C70.3901 115.49 80.1591 125.235 80.1591 137.267C80.1591 149.211 70.3901 159 58.4693 159C46.4624 159 36.7363 149.211 36.7363 137.267C36.7363 134.722 37.2097 132.006 38.0704 129.591Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.453 129.591C257.595 121.182 265.858 115.49 274.852 115.49C286.773 115.49 296.542 125.235 296.542 137.267C296.542 149.211 286.773 159 274.852 159C262.845 159 253.119 149.211 253.119 137.267C253.119 134.722 253.592 132.006 254.453 129.591Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5096 142.183C69.4439 147.616 64.1935 151.239 58.4698 151.239C50.8525 151.239 44.5693 144.943 44.5693 137.31C44.5693 129.677 50.8525 123.382 58.4698 123.382C66.0871 123.382 72.3703 129.677 72.3703 137.31C72.3703 138.949 72.0691 140.717 71.5096 142.183Z",
    fill: "#EBE9E9",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.891 142.183C285.826 147.616 280.575 151.239 274.852 151.239C267.234 151.239 260.951 144.943 260.951 137.31C260.951 129.677 267.234 123.382 274.852 123.382C282.469 123.382 288.752 129.677 288.752 137.31C288.752 138.949 288.451 140.717 287.891 142.183Z",
    fill: "#EBE9E9",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4466 114.801C15.0468 116.224 11.4748 115.965 8.33324 116.396C7.60164 116.482 6.69789 115.879 6.61182 114.628C6.39664 111.351 8.50536 105.443 11.0014 104.408C12.8089 103.675 15.0468 103.114 17.801 102.769C19.006 102.597 23.9982 102.166 27.398 102.381C26.4512 106.219 22.4919 113.119 18.4466 114.801Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.865 73.4902C52.4879 75.6895 50.5943 76.9832 48.4856 78.1906C42.6758 81.4248 26.5374 92.4209 22.1048 96.6038C17.1127 101.304 17.6721 100.959 17.5 102.857",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.734 37.2238L124.486 69.0911C124.314 74.7833 119.58 77.7156 116.352 78.4056C84.7209 85.0895 53.3481 90.4367 22.6638 98.9318C16.0793 100.743 14.1857 102.252 10.3125 103.848",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8258 77.3705C80.4171 76.6805 99.3958 74.395 116.653 71.9802C121.688 71.2471 122.721 67.7542 123.065 64.3906L125.776 36.9217C125.949 35.4556 123.969 34.0756 122.549 34.0756C114.759 33.9894 104.001 33.6875 97.3731 35.0243C94.4036 35.628 92.9404 36.5336 91.4341 38.086C81.3638 48.5216 68.7544 61.7602 60.2334 72.627C57.0057 76.7667 54.0794 77.6292 61.8258 77.3705Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8881 36.9639L90.4883 74.6097C91.9945 74.4372 93.5438 74.3079 95.0931 74.0923C102.194 73.3161 109.51 72.2811 116.611 71.3324C120.742 70.7287 122.119 68.1845 122.507 64.3035L125.218 36.8777C125.003 34.0747 120.613 34.6784 118.763 34.5922C112.565 34.5922 106.325 34.4197 100.128 35.1959C97.7613 35.4547 95.7387 35.8859 93.8881 36.9639Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2825 74.7398L92.7254 37.7839C92.4241 38.0427 92.1229 38.3014 91.9077 38.517C85.2372 45.4166 78.5668 52.4887 72.1545 59.647C71.552 60.38 70.0888 62.4499 70.0027 63.2261C69.4863 68.487 69.6154 72.713 70.0027 76.3784C76.372 75.9903 82.8703 75.3866 89.2825 74.7398Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.767 138.301L129.178 103.674V34.0313C129.178 31.6596 127.671 30.8834 125.476 30.8834C116.224 30.8403 108.477 31.2715 99.6121 32.3927C95.911 32.867 92.0378 33.8589 88.4228 37.783L65.1836 63.3976C63.8926 64.7775 64.0648 64.217 64.0648 65.5537L64.366 77.4124L63.8496 111.522",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.767 138.301L129.178 103.674V34.0313C129.178 31.6596 127.671 30.8834 125.476 30.8834C116.224 30.8403 108.477 31.2715 99.6121 32.3927C95.911 32.867 92.0378 33.8589 88.4228 37.783L65.1836 63.3976C63.8926 64.7775 64.0648 64.217 64.0648 65.5537L64.366 77.4124L63.8496 111.522",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8924 106.047C50.4653 105.098 37.4255 109.54 35.0586 118.725",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.914 83.5798H124.271C124.615 83.5798 124.873 83.8386 124.873 84.1835V86.2534C124.873 86.5984 124.615 86.8571 124.271 86.8571H120.914C120.57 86.8571 120.312 86.5984 120.312 86.2534V84.1835C120.312 83.8386 120.57 83.5798 120.914 83.5798Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.635 84.3118C123.108 84.3118 123.495 84.6997 123.495 85.2169C123.495 85.691 123.108 86.0788 122.635 86.0788C122.118 86.0788 121.731 85.691 121.731 85.2169C121.731 84.7428 122.118 84.3118 122.635 84.3118Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.396 140.802C307.603 141.278 324.042 141.191 329.207 140.802",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298.909 127.521H343.064",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M323.869 118.638L297.661 118.811C295.939 118.811 294.476 116.223 296.542 116.223L325.505 116.051C326.839 116.051 327.57 118.552 325.505 118.638H324.515",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250.451 119.674L86.3569 121.398C84.076 121.398 84.162 118.25 85.7543 118.25L253.033 116.526C255.701 116.482 253.851 119.674 252.474 119.674H251.57",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M343.106 117.603H329.249",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M198.937 70.7714L143.766 71.7201C141.399 71.7201 139.161 69.6502 139.161 67.106V38.6884C139.161 36.1441 141.227 34.0743 143.766 34.0743L201.347 33.1256C203.887 33.0825 205.952 35.3679 205.952 37.7397V66.1573C205.952 68.4859 203.671 70.7714 201.347 70.7714H200.315",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M317.844 69.0909L268.31 69.9103L217.141 70.7727C214.86 70.7727 212.536 68.7028 212.536 66.1586V37.741C212.536 35.1968 214.602 33.1269 217.141 33.1269L270.763 32.2645L320.211 31.4451C322.75 31.402 324.816 33.8169 324.816 36.0592V64.4768C324.816 66.7623 322.449 69.0909 320.211 69.0909H319.178",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.087 69.0906L145.616 69.8237C141.442 69.8668 141.012 67.7538 141.012 65.2096V40.5005C141.012 37.1801 143.077 35.8864 145.616 35.8864L199.454 35.1533C202.682 35.1102 204.059 36.792 204.059 39.7674V64.4334C204.059 67.8401 202.682 69.0475 199.454 69.0475H198.421",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.95 67.2796L265.857 68.2283L218.991 68.832C214.86 68.8751 214.387 66.7621 214.387 64.2179V39.5519C214.387 36.2315 216.452 34.9379 218.991 34.9379L267.622 34.3342L318.36 33.3855C321.588 33.3423 322.965 35.1535 322.965 37.9996V62.6655C322.965 66.0291 321.545 67.2796 318.36 67.2796H317.328",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M341.084 47.8318L333.166 48.1768C332.348 48.1768 332.219 48.7805 332.219 49.1255L332.262 52.7046C332.262 53.4377 332.993 53.6533 333.209 53.6533L341.601 54.602",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M342.332 108.935L333.768 109.28C332.95 109.28 332.821 109.884 332.821 110.229L332.864 113.808C332.864 114.498 333.639 114.756 333.811 114.756L342.849 115.705",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 115.921V119.242",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 116.396V119.242",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6095 118.638C35.3592 125.106 33.5947 134.981 32.1315 141.794C23.9548 143.174 19.7372 143.174 12.6794 141.191C8.54798 140.069 0.672522 136.49 1.10288 131.876L1.83446 123.597C2.0066 121.484 2.95338 119.759 4.20141 119.5C4.20141 119.414 4.20141 119.328 4.20141 119.284L40.6095 118.638Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65234 120.794L39.4046 120.104",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7285 73.3594H43.8373C54.9835 60.4227 71.4231 43.5619 84.635 30.927C84.678 30.8839 84.678 30.8839 84.678 30.8839L91.6067 31.272C79.4277 44.7262 65.6993 59.7759 53.8215 73.4025L41.7285 73.3594Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0753 31.4882C71.1647 43.8643 55.3276 60.1646 44.3535 72.7994H53.6061C56.5756 69.4359 59.5881 65.943 62.6436 62.5794C71.7671 52.2301 81.1058 42.0963 90.3584 31.8332L84.0753 31.4882Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250.537 138.13L90.015 138.863C89.4125 138.863 88.7238 138.605 88.6378 138.001C85.5392 121.313 79.17 108.203 63.9785 106.047",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83984 104.883C11.0879 101.821 13.2827 98.2418 16.9407 94.9645C23.9125 88.7117 32.0461 83.149 40.438 77.5431L43.3215 73.4033",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2011 77.4133H49.432H36.6074",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2011 77.4133H49.432H36.6074",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.441 102.381C38.7163 101.044 50.6372 100.139 63.9782 100.009L323.654 97.2065C325.419 97.1634 326.237 98.7158 326.237 99.9663C326.237 101.217 326.366 102.683 323.654 102.683L63.9782 105.486C51.3258 105.572 38.4151 106.09 25.8057 106.737",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M343.193 108.806C343.15 100.095 343.02 92.549 342.805 83.9245C339.19 84.5282 334.844 91.4709 334.844 94.4032V106.262C334.844 107.685 335.102 108.849 337.555 108.849H343.193V108.806Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M343.064 93.1534C343.107 94.5765 343.107 95.9995 343.107 97.4226H334.844V94.3609C334.844 93.9728 334.93 93.5847 335.016 93.1534H343.064Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M343.15 97.4216C343.193 99.2759 343.192 101.13 343.192 103.028H334.887V97.4216H343.15Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M254.453 129.591C257.594 121.139 265.857 115.49 274.895 115.49C286.773 115.49 296.585 125.236 296.585 137.267C296.585 138.216 296.542 139.121 296.412 140.027H301.017C301.017 140.027 301.017 139.984 300.974 139.984C300.157 129.85 295.595 118.121 288.322 114.283C282.985 111.437 269.214 111.48 263.361 114.283C255.227 118.121 250.795 128.556 250.537 138.949C250.494 139.337 250.364 139.682 250.235 140.027H253.334C253.205 139.121 253.162 138.216 253.162 137.267C253.162 134.68 253.592 132.006 254.453 129.591Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1141 129.548C41.2557 121.182 49.5185 115.447 58.5129 115.447C70.4768 115.447 80.2029 125.279 80.2029 137.224C80.2029 138.259 80.1598 139.293 80.0307 140.242H83.6027C82.0964 125.236 75.469 115.361 67.9378 112.385C62.3432 110.229 53.693 111.135 48.5287 112.946C37.3825 116.784 34.5422 130.755 32.5195 140.242H36.9952C36.8661 139.25 36.78 138.259 36.78 137.224C36.737 134.722 37.2534 131.963 38.1141 129.548Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.775 142.312H191.062L190.374 144.64L161.11 145.072L159.775 142.312Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3073 97.8965C58.567 97.8965 59.5881 97.3752 59.5881 96.7322C59.5881 96.0892 58.567 95.5679 57.3073 95.5679C56.0476 95.5679 55.0264 96.0892 55.0264 96.7322C55.0264 97.3752 56.0476 97.8965 57.3073 97.8965Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0646 59.5601L66.7759 58.5252C67.5936 58.1802 68.2391 59.3876 68.3682 60.1207C69.6162 65.3385 70.7351 70.6425 70.3908 75.9035C70.3478 76.6365 69.5732 77.499 68.7986 77.499H65.1835C64.4519 77.499 63.7634 76.7228 63.5912 75.9035C62.5584 71.2894 62.1711 66.5891 62.4724 61.8456C62.5154 61.0263 63.247 59.9051 64.0646 59.5601Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15928 107.642C3.42767 110.574 3.64281 113.808 4.1162 119.242H6.3971C6.3971 115.102 6.35405 111.523 8.20457 107.642H4.15928Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3617 133.731C1.10349 133.127 1.01733 132.48 1.06037 131.833L1.57688 126.529H11.3889C12.2066 126.529 13.0673 127.262 12.8951 128.039L12.1635 131.532C11.9914 132.308 11.4319 133.041 10.6573 133.041L1.3617 133.731Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 126.531L36.4357 126.314",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M208.233 21.2676L208.965 142.01",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M336.479 20.6642L164.251 21.8716C156.375 21.9147 124.313 21.8285 105.98 24.2433C99.3529 25.1058 96.2543 26.7013 91.5635 31.2723",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M336.091 13.7642L148.242 14.9716C140.409 15.0147 122.851 14.1523 115.75 17.3433C109.682 20.0169 104.216 21.0518 99.5254 25.6228",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1588 27.0463L89.1973 26.5288",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M147.553 2.12177V22.0443",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M259.661 1V13.8505",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M314.961 1V13.8073",
    stroke: "#939EAF",
    strokeWidth: 0.455856,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleLeftSide);
export default __webpack_public_path__ + "static/media/vehicle-left-side.beb4408d0cfdaea38c6b2ff0504ab869.svg";
export { ForwardRef as ReactComponent };